/* src/app/global/components/global-accountinfo/global-accountinfo.component.scss */
:host {
  background-color: rgba(0, 0, 0, 0.2);
  cursor: pointer;
  width: 60px;
}
.cw-global-header-usericon {
  border-radius: 50%;
  height: 40px;
  overflow: hidden;
  width: 40px;
}
/*# sourceMappingURL=global-accountinfo.component.css.map */
